import * as types from '../../../actions/index.types';

const initialState = {
    accountLedgerReport: null,
    loading: false,
    error: null,
};

const accountLedgerReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_ACCOUNT_LEDGER_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
                accountLedgerReport: null,
            };
        case types.GET_ACCOUNT_LEDGER_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                accountLedgerReport: action.payload,
            };
        case types.GET_ACCOUNT_LEDGER_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                accountLedgerReport: null,
            };
        default:
            return state;
    }
};

export default accountLedgerReportReducer;
